import { Box } from '@mui/material';
import { CasRenderAsOfString } from 'src/compass/shared/components';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';

// CasRenderAsOfString right-aligns its lines; this keeps a text column left-aligned under its header.
export function CasRenderAsOfStringLeft(props: ICasRenderCellProps) {
  return (
    <Box sx={{ '& .MuiBox-root': { textAlign: 'left' } }}>
      <CasRenderAsOfString {...props} />
    </Box>
  );
}
